export default function Footer() {
  return (
    <footer className="bg-bleuClair py-4 text-center text-xs text-white">
      <a
        href="/mentions-legales"
        className="hover:text-orange transition-colors duration-500">
          Crédits et Mentions Légales
      </a>
      <br />

      © {new Date().getFullYear()} FME - Festival de Musique d'Ensemble. <br className="block sm:hidden"/>
      Tous droits réservés<span className="hidden sm:inline-block">&nbsp;|&nbsp;</span><br className="block sm:hidden"/>
      Création Julilo Design ® -&nbsp;
      <a
        href="https://www.julilo.com"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-orange transition-colors duration-500"
      >
         www.julilo.com
      </a>
    </footer>
  );
}